import { jsonObject } from 'typedjson';

@jsonObject
export class SignUpAsClientResponse {}
